import Main from './OrdersMain'

const Orders = {
  Main,
}

export default Orders
